<template>
  <svg
    class="custom-icon"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.6 5.39504e-05H12V2.40009H15.6V6.00002H18V2.40009C18 1.76351 17.7472 1.15312 17.2971 0.702961C16.847 0.252803 16.2365 5.39504e-05 15.6 5.39504e-05Z"
    />
    <path
      d="M5.39504e-05 2.40004V5.99996H2.40009V2.40004H6.00002V0H2.40009C1.76351 0 1.15312 0.252791 0.702961 0.702907C0.252803 1.15302 5.39504e-05 1.76345 5.39504e-05 2.40004Z"
    />
    <path
      d="M2.40004 12H0V15.5999C0 16.2365 0.252792 16.8469 0.702907 17.297C1.15302 17.7472 1.76345 17.9999 2.40004 17.9999H5.99997V15.5999H2.40004V12Z"
    />
    <path
      d="M15.6 15.6H12V18H15.6C16.2365 18 16.8469 17.7472 17.2971 17.2971C17.7473 16.847 18 16.2365 18 15.6V12H15.6V15.6Z"
    />
    <path
      d="M5 6C5 5.44772 5.44772 5 6 5H12C12.5523 5 13 5.44772 13 6V12C13 12.5523 12.5523 13 12 13H6C5.44772 13 5 12.5523 5 12V6Z"
    />
  </svg>
</template>
